/**
 * Named island archetypes, shared by the Island Lab and (later) the game's world
 * generator, so a lab preset and an island in the world are the same thing.
 */
import type { IslandOptions } from "./types";

export const ISLAND_ARCHETYPES = {
  /** The pitch picture's island: three terraces, tower on the hill, tarn and sheep. */
  amberholm: { radius: 7, levels: 3, flora: 1, landmark: "bell-tower" },
  /** A tiny stepping-stone isle. */
  islet: { radius: 3, levels: 2, flora: 1.2, landmark: "none", tarn: false },
  /** A broad low meadow with an archway. */
  meadow: { radius: 9, levels: 2, flora: 0.8, landmark: "sun-arch" },
  /** A tall, wooded isle with four terraces and a slightly deeper keel. */
  highland: { radius: 10, levels: 4, flora: 1.4, keelDepth: 12, landmark: "bell-tower" },
} as const satisfies Record<string, IslandOptions>;

export type IslandArchetype = keyof typeof ISLAND_ARCHETYPES;
